import { Injectable } from '@angular/core';
import { gql } from 'apollo-angular';

import { ApiQuery } from '../../../../common/model/api.query';
import { Auth0ConnectionOutput } from '../model/auth0-connection.output';

export interface FetchUserNetworkInfoParams {
	readonly auth0UserId: string;
}

@Injectable({ providedIn: 'root' })
export class FetchUserNetworkInfoApiQuery extends ApiQuery<
	Auth0ConnectionOutput,
	FetchUserNetworkInfoParams
> {
	client = 'iam';
	document = gql`
		query FetchUserNetworkInfo($auth0UserId: String!) {
			fetchUserNetworkInfo(auth0UserId: $auth0UserId) {
				userId
				provider
				accessToken
				refreshToken
				expirationTimestamp
			}
		}
	`;
	method = 'fetchUserNetworkInfo';
}
